import { render, staticRenderFns } from "./Cashier copy.vue?vue&type=template&id=0f7faeab"
import script from "./Cashier copy.vue?vue&type=script&lang=js"
export * from "./Cashier copy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports